import createIcon from '@/lib/create-icon'

const HomeIcon = createIcon(
  <svg
    width='23'
    height='24'
    viewBox='0 0 23 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M17.0782 8.25458C17.9693 8.87834 18.5 9.89764 18.5 10.9853V15.6665C18.5 17.5074 17.0076 18.9998 15.1667 18.9998H13.5V15.6665C13.5 14.746 12.7538 13.9998 11.8333 13.9998H10.1667C9.24619 13.9998 8.5 14.746 8.5 15.6665V18.9998H6.83333C4.99238 18.9998 3.5 17.5075 3.5 15.6665V10.9854C3.5 9.89764 4.0307 8.87834 4.92179 8.25458L9.08846 5.33791C10.2362 4.5345 11.7638 4.5345 12.9115 5.33791L17.0782 8.25458Z'
      stroke='currentColor'
      strokeWidth='1.5'
      strokeLinejoin='round'
      fill='transparent'
    />
  </svg>,
  'HomeIcon'
)

export default HomeIcon
